var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "lpu_affiliation" } },
    [
      _c(
        "a",
        {
          staticClass: "text-body-1 text--text link-decoration-none",
          attrs: {
            "data-qa": "lpu_affiliation_lpu_type_link",
            href: _setup.reverseFullL10N({
              name: "lpulist",
              args: {
                language: _setup.urlLang,
                town_translit: _vm.lpu.town.translit,
                lpu_type_translit: _vm.lpu.lputype.translit,
              },
            }),
          },
        },
        [_vm._v(_vm._s(_setup.tDynamic(_vm.lpu.lputype, "name")))]
      ),
      _vm._v(" "),
      _vm.lpu.lpuset
        ? [
            _c("span", { staticClass: "text-body-1 text-secondary--text" }, [
              _vm._v(
                "\n      · " +
                  _vm._s(_setup.tStatic("в составе сети")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "text-body-1 primary--text link-decoration-none",
                attrs: {
                  "data-qa": "lpu_affiliation_lpuset_link",
                  href: _setup.reverseFull({
                    name: "lpuset",
                    args: [
                      _vm.lpu.lpuset.town.translit,
                      _vm.lpu.lpuset.translit,
                    ],
                  }),
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.tDynamic(_vm.lpu.lpuset, "name")) +
                    "\n    "
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }